import {
  icons_exports
} from "./chunk-EBGWIVMA.mjs";
import {
  illustrations_exports
} from "./chunk-QGHLBQCR.mjs";

// src/stone/index.ts
var icons = { ...icons_exports, ...illustrations_exports };

export {
  icons
};
